import axios from 'axios';
import { FacilityModel } from '../models/facility';

export const getFacilities = async (
    ids: number[]
): Promise<FacilityModel[]> => {
    const response = await axios.post(
        '/api/facility',
        ids
    );
    return response.data;
};

export const getOtherFacilities = async (
    ids: number[]
): Promise<FacilityModel[]> => {
    const response = await axios.post(
        '/api/facility/other',
        ids
    );
    return response.data;
};
